import React from 'react';
import PropTypes from 'prop-types';

import './styles.module.css';

const QuestionnaireHeader = ({ title, description }) => (
  <div styleName="header">
    <h3 styleName="title">{title}</h3>
    <p styleName="context">{description}</p>
  </div>
);

QuestionnaireHeader.propTypes = {
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  title: PropTypes.string.isRequired
};

export default QuestionnaireHeader;